<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.criteria') }}</template>
					<template #content>
						<!-- CRITERES SEARCH -->
						<div class="datatable">
							<div class="card mb-4" style="width:100%">
								<div class="card-header">
									<!-- <div id="panelList" class="card-body  panel-collapse collapse in show"> -->
									<div class="form-row">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.mvtRefund')}}
												</label>
												<select v-model="instance.mvtRefund" class="form-control" multiple>
													<option v-for="mvtRefund in mvtRefundList" :value="mvtRefund.id" :key="mvtRefund.id">
													{{ mvtRefund.lib}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountInf', { obj: $t(instanceClassAttr.instanceClass+'.amountRefund')} ) }}</label>
												<input type="number" step="any" v-model="instance.amountRefundInf" class="form-control" @input="amountToLetter($event, 'inf')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.inf != '' " class="amount-letter">
													{{amountLetter.inf}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountEq', { obj: $t(instanceClassAttr.instanceClass+'.amountRefund')})}}</label>
												<input type="number" step="any" v-model="instance.amountRefundEq" class="form-control" @input="amountToLetter($event, 'eq')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.eq != '' " class="amount-letter">
													{{amountLetter.eq}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountSup', { obj: $t(instanceClassAttr.instanceClass+'.amountRefund')})}}</label>
												<input type="number" step="any" v-model="instance.amountRefundSup" class="form-control" @input="amountToLetter($event, 'sup')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.sup != '' " class="amount-letter">
													{{amountLetter.sup}}
												</span>
											</div>
										</div>
										
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t('default.dateEntryAfter')}}</label>
												<input type="date" v-model="instance.dateEntryAfter" class="form-control" />
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t('default.dateEntryBefore')}}</label>
												<input type="date" v-model="instance.dateEntryBefore" class="form-control" />
											</div>
										</div>
									</div> <!--end form-row-->
									<div style="text-align:center">
										<b-button class="btn btn-primary btn-sm"
											@click="search()">
											<fa icon="search"/>
												&nbsp; {{ $t('vtabTrans.sSearch') }}
										</b-button>
										<button class="btn btn-light btn-sm" @click="reset()">
											<fa icon="refresh"/>
											&nbsp; {{ $t('vtabTrans.sReset') }}
										</button>
									</div>

										<!-- </div> -->
								</div>
							</div> <!--end card-body-->
							
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel :expanded="false">
					<template #title>{{ $t('panel.chart') }}</template>
					<template #content>
						<!-- STATS -->
						<div>
							<chart
								:typeStats="typeStats"
								:chartData="chartData"
								:chartOptions="chartOptions"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>
						<!-- DATA -->
						<div class="datatable">
							<datatable-instance
								:instanceClassAttr="instanceClassAttr"
								ref="componentDatatableInstance"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
			</vue-collapsible-panel-group>
		
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	import Chart from '@/components/templates/charts/Chart.vue';

	export default {
		name: 'mvtRefundItemList',
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
			'chart': Chart
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('mvtrefund.label'),
				pageTitle: this.$t('mvtrefund.list'),
				pageIcon: 'list',
				instanceClassAttr: {
					instanceClass: 'mvtrefunditem',
					titleIndex: 'nav.mvt',
					iconClass: 'folder',
					actCol: {
						actDisplay: false, 
						thCol: '10%', 
						actAdd: false, 
						actGet: false, 
						actEdit: false, 
						actDel: false, 
						actPrint: 'produce'
					},
					attrsList: [
						{attrName: 'prsPersonLib', attrCol: '25%', searchable: false, sortable: true},
						{attrName: 'mvtRefundLibShort', attrRep:'mvtRefund', attrCol: '15%', searchable: false, sortable: true},
						{attrName: 'amountTot', attrCol: '15%', searchable: false, sortable: true},
						{attrName: 'amountRefund', attrCol: '15%', searchable: false, sortable: true},
						{attrName: 'justificatif', attrCol: '15%', searchable: false, sortable: true},
						{attrName: 'dateCreated', attrCol: '10%', searchable: false, sortable: true},
					]
				},
				instance: {
					mvtRefund: [],
					amountRefundInf: '',
					amountRefundeq: '',
					amountRefundSup: '',
					dateEntryAfter:'',
					dateEntryBefore:''
				},
				mvtRefundList: [],
				amountLetter: {},		
				chartOptions: {
					title: 'Statistique des ristournes par ',
					hAxis: {title: 'Client'},
					vAxis: {title: 'Montant', format: '##,###.##' }
				},
				chartData: [],
				typeStats: [
					{id: 'refund', label: 'Ristournes'},
					{id: 'tot', label: 'Mouvements'}
				],
				typeStat: 'refund',
			}
		},
		async mounted () {
			if(this.$store.getters.loggedIn) {
				// GET LIST mvtRefundList
				await this.$store.dispatch('axiosGet', {
					domain: 'mvtrefund'
				})
				.then(response => {
					this.mvtRefundList = response.data
				})
				.catch(error => {
					console.log('error catch mvtRefundList == ', error.message)
				})
			}
			this.reset()
		},
		methods: {
			reset(){
				this.instance= {
					mvtRefund: [],
					amountRefundInf: '',
					amountRefundeq: '',
					amountRefundSup: '',
					dateEntryAfter:'',
					dateEntryBefore:''
				}
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async search() {
				let strParamsForms = "";

				let titreDoc = this.$t(this.instanceClassAttr.instanceClass +'.list')
				
				let	detailsTopC1 = '';
				let	detailsTopC2 = '';
				// Date super
				strParamsForms = strParamsForms+"&params1=dateCreated&valParams1="+this.instance.dateEntryAfter+"&logParams1=geD"
				if(this.instance.dateEntryAfter){
					detailsTopC2 = '<i>'+this.$t('default.dateEntryAfter')+' </i><b> '+ this.$moment(this.instance.dateEntryAfter).format(this.$store.getters.formatDateShort) + '</b>'
				}
				// Date inf
				strParamsForms = strParamsForms+"&params2=dateCreated&valParams2="+this.instance.dateEntryBefore+"&logParams2=leD"
				if(this.instance.dateEntryBefore){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + ' - '
					else
						detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryAfter')+' </i><b> ... </b>'

					detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryBefore')+' </i><b> '+ this.$moment(this.instance.dateEntryBefore).format(this.$store.getters.formatDateShort) + '</b>'
				}
				strParamsForms = strParamsForms+"&params3=mvtRefund.id&valParams3="+this.instance.mvtRefund +"&logParams3=inL"
			
				// Amout super
				strParamsForms = strParamsForms+"&params6=amountRefund&valParams6="+this.instance.amountRefundSup+"&logParams6=geDo"
				if(this.instance.amountRefundSup){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.amountRefund')+' >= </i><b>'+this.$store.getters.formatAmount(this.instance.amountRefundSup) + '</b>'
				}
				// Amout equal
				strParamsForms = strParamsForms+"&params7=amountRefund&valParams7="+this.instance.amountRefundEq+"&logParams7=eqDo"
				if(this.instance.amountRefundEq){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.amountRefund')+' = </i><b> '+this.$store.getters.formatAmount(this.instance.amountRefundEq) + '</b>'
				}
				// Amout inf
				strParamsForms = strParamsForms+"&params8=amountRefund&valParams8="+this.instance.amountRefundInf+"&logParams8=leDo"
				if(this.instance.amountRefundInf){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.amountRefund')+' <;= </i><b> '+this.$store.getters.formatAmount(this.instance.amountRefundInf) + '</b>'
				}

				strParamsForms = strParamsForms+ "&titreDoc="+ titreDoc
				if(detailsTopC1 != '')
					strParamsForms = strParamsForms+"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParamsForms = strParamsForms+"&detailsTopC2="+detailsTopC2
				
				this.$refs.componentDatatableInstance.setStrParamsForms(strParamsForms);
				this.$refs.componentDatatableInstance.getDataByCriteria();
			},
			drawChart(val) {
				if(val && !Array.isArray(val))
					this.typeStat = val
				
				// default values
				let statLabel = ["Client", "Ristournes par Client"] 
				let attrKey = 'prsPersonLib'
				let attrValue = 'amountRefund'
				
				if(this.typeStat === 'refund' )
					attrValue = 'amountRefund'
				else if(this.typeStat === 'tot' ){
					statLabel = ["Client", "Mouvements par Client"] 
					attrValue = 'amountTot'
				}
				
				var dataList = this.$refs.componentDatatableInstance.drawChart(attrKey, attrValue, null)
				this.chartData = [ statLabel ]
				dataList?.forEach(data => {
					this.chartData.push(data);	
				});
			},
		}
		
	}

</script>